// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1hZ41","amount":"Amount_amount__SWHAX","tip":"Amount_tip__1wv28","tipHeader":"Amount_tipHeader__2Dvmf","tipsWrap":"Amount_tipsWrap__7Nehs"};